import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default function Copyright() {
    return (
      <Typography variant="body2" color="primary" align="center">
        {'© '}
        <Link color="primary" href="https://repairify.com/">
          Repairify
        </Link>
        {' '} {new Date().getFullYear()}
      </Typography>
    );
}
  